module.exports = __webpack_public_path__ + "media/images/brand-assets/icook_logo_color-d93c60705a80046d6ebc024dcfb6e002.png";